<template>
  <div :class="ui.bkgdColor">
      <v-layout class="text-xs-right mt-2 mr-2">
        <v-spacer/>
        <v-btn :color="ui.textSubheading"
        :disabled="getInventoryList.length > 30"
        flat icon @click="openDialog()">
          <v-icon :color="ui.btnColor"> add </v-icon>
        </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card :color="ui.bkgdColor" :text-color="ui.bkgdColor">
          <v-card-title class="title wplblue0--text">
            New Storage
          </v-card-title>
          <v-progress-linear color="blue-grey" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row class="mr-2">
                <v-flex xs6>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="title"
                  hint="storage location"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="localForm.id"
                  :rules="ruleMustBeFilledANDLessThan50"
                  prepend-icon="fingerprint"
                  hint="storage id"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs3>
                  <v-select
                  v-model="localForm.type"
                  :items="inventoryTypeOptions"
                  :rules="ruleMustBeSelected"
                  prepend-icon="grid_view"
                  hint="type"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                  v-model="localForm.crit"
                  :items="inventoryThemeOptions"
                  prepend-icon="priority_high"
                  hint="crit"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                  v-model="localForm.haz"
                  :items="inventoryHazardOptions"
                  prepend-icon="warning"
                  hint="hazard"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
                <v-flex xs3>
                  <v-select
                  v-model="localForm.owner"
                  :items="inventoryOwnerOptions"
                  prepend-icon="manage_accounts"
                  hint="owner"
                  persistent-hint
                  required
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs6>
                  <v-text-field
                  v-model="localForm.ibound"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="login"
                  hint="inbound requirements"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model="localForm.obound"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="logout"
                  hint="outbound requirements"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs4>
                  <v-text-field
                  v-model="localForm.stomin"
                  :rules="ruleNumberPositive"
                  prepend-icon="archive"
                  hint="min"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                  v-model="localForm.stomax"
                  :rules="ruleNumberPositive"
                  prepend-icon="unarchive"
                  hint="max"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                  v-model="localForm.stoord"
                  :rules="ruleNumberPositive"
                  prepend-icon="shopping_bag"
                  hint="on order"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-text-field
                  v-model="localForm.stocur"
                  :rules="ruleNumberPositive"
                  prepend-icon="inventory2"
                  hint="available"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="localForm.spons"
                  :rules="ruleMustBeNotUndefinedANDLessThan50"
                  prepend-icon="manage_accounts"
                  hint="stock ownership"
                  persistent-hint
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row :class="ui.textSubheading">
                <div class="ml-4 mt-4 mb-2">
                  Material Location Storage
                </div>
              </v-layout>
              <v-layout row class="ml-2 mr-2">
                <v-flex xs12>
                  <v-textarea
                  v-model="localForm.des"
                  :disabled="false"
                  :outline="true"
                  required
                  :rules="ruleMustBeNotUndefinedANDLessThan1000"
                  hint="additional storage requirements"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
          <v-layout row>
            <v-btn @click="closeDialog()" color="wplblue0" flat>
              <v-icon left> exit_to_app </v-icon>
              Close
            </v-btn>
            <v-spacer/>
            <v-btn @click="validate" color="wplblue0" flat
            >
              <v-icon left> add </v-icon>
              add
            </v-btn>
          </v-layout>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import rulesTextfield from "@/data/rules/mixins/rulesTextfield.js";
import master from "@/data/forms/mixins/master.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import inventoryOptions from "@/data/options/mixins/inventoryOptions.js";
import uisettings from "@/frame/theme/mixins/uisettings.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import moment from "moment";

export default {
  // eslint-disable-next-line
  mixins: [
    techOptions,
    listFunctions,
    generateForms,
    master,
    inventoryOptions,
    rulesTextfield,
    uisettings,
    generateID,
    docRevsModFunctions
  ],
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getInventoryList",
      "getInventoryListCounter",
      "getDetail",
      "getUser"
    ]),
    ui() {
      return this.uiTheme1;
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      localForm: {
        id: "STOCK ID 1",
        title: "W01.BL08.SEC12",
        type: "C", // typ
        crit: "C0",
        haz: "H0",
        com: "", // change is stock level
        owner: "S", // who is doing it
        spons: "", // sponsor
        stomin: 0, // minin order
        stomax: 0, // stooage capaicty
        stoord: 0, // on order
        stocur: 0, // current stock level
        ibound: "", // inbound instructions
        obound: "", // outbound instructions
        des: "Not Required." // desciption of storage =
      }
    };
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog() {
      this.dialog = true;
      // this.$store.dispatch("changeInventoryList", []);
      // this.$refs.form.reset();
    },
    validate() {
      if (this.$refs.form.validate() === true) {
        // NEW PART INVENTORY
        let tempForm = this.generateInventoryForm();
        // BASIC
        tempForm.basic.idg = this.generateIDG("date-gid");
        tempForm.basic.did = this.generateDID("DATE", "L7");
        tempForm.basic.idi = this.getInventoryListCounter + 1;
        tempForm.basic.title = this.localForm.title;
        tempForm.basic.id = this.localForm.id;
        tempForm.basic.tag = "L7";

        // CHAR
        tempForm.char.type = this.localForm.type;
        tempForm.char.crit = this.localForm.crit;
        tempForm.char.haz = this.localForm.haz;
        tempForm.char.des = this.localForm.des;
        tempForm.char.stomax = this.localForm.stomax;
        tempForm.char.stomin = this.localForm.stomin;
        tempForm.char.stocur = this.localForm.stocur;
        tempForm.char.stoord = this.localForm.stoord;
        tempForm.char.ibound = this.localForm.ibound;
        tempForm.char.obound = this.localForm.obound;
        tempForm.char.owner = this.localForm.owner;
        tempForm.char.spons = this.localForm.spons;

        // STATS
        tempForm.stats.dcrt = moment().format();
        tempForm.stats.uname = this.getUser.basic.title;
        tempForm.stats.uemail = this.getUser.basic.email;
        tempForm.stats.udid = this.getUser.basic.did;

        // LIST UPDATE
        var tempList = this.getInventoryList;
        var obj = Object.assign({}, tempForm);
        var parseobj = JSON.parse(JSON.stringify(obj));
        var newList = this.appendItemLimited(parseobj, tempList, 12);

        // STORE UPDATE
        this.$store.dispatch("changeInventoryList", newList);
        // eslint-disable-next-line
        this.$store.dispatch("changeInventoryListCounter", tempForm.basic.idi);
        this.saveDocumentRevMod(5.11, 1); // attachment added.
        this.$store.dispatch("changeDataSavePendingIndication", true);

        // Close Window
        this.dialog = false;
      }
    }
  }
};
</script>
